<div [@slide]="activePane" class="fx-row fx-row-h-space-between" id="parent">
  @if (activePane === 'left' || transitioning) {
    <div
      class="child"
      [class.show]="activePane === 'left' || transitioning"
      >
      <ng-content select="[leftPane]"></ng-content>
    </div>
  }
  @if (activePane === 'right' || transitioning) {
    <div
      class="child"
      [class.show]="activePane === 'right' || transitioning"
      >
      <ng-content select="[rightPane]"></ng-content>
    </div>
  }
</div>
